module.exports = __webpack_public_path__ + "static/media/rating_0.d2c6c936.svg";